"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getZipCodeProps = exports.getZipCodeErrorMessages = exports.getStateProps = exports.getStateErrorMessages = exports.getNameErrorMessages = exports.getCountryProps = exports.getCountryErrorMessages = exports.getCityProps = exports.getCityErrorMessages = exports.getCardNumberProps = exports.getCardNumberErrorMessages = exports.getCardExpiryProps = exports.getCardExpiryErrorMessages = exports.getCardCVVProps = exports.getCardCVVErrorMessages = exports.getAddressLineTwoProps = exports.getAddressLineTwoErrorMessages = exports.getAddressLineProps = exports.getAddressLineErrorMessages = void 0;
var _fieldsMessages = require("../../components/fields/fieldsMessages");
var _nativePaymentValidations = require("./nativePaymentValidations");
var _validations = require("../validations");
var _nativePaymentUtils = require("./nativePaymentUtils");
var getCardNumberErrorMessages = function getCardNumberErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.cardNumberFieldMessages.invalidCardNumber),
    cardTypeNotSupported: formatMessage(_fieldsMessages.cardNumberFieldMessages.cardTypeNotSupported)
  };
};
exports.getCardNumberErrorMessages = getCardNumberErrorMessages;
var getCardNumberProps = function getCardNumberProps(formatMessage) {
  return {
    errorMessages: getCardNumberErrorMessages(formatMessage),
    formatValue: _nativePaymentUtils.formatCardNumber,
    label: formatMessage(_fieldsMessages.cardNumberFieldMessages.fieldLabel),
    name: 'cardNumber',
    placeholder: formatMessage(_fieldsMessages.cardNumberFieldMessages.fieldPlaceholder),
    validate: _nativePaymentValidations.validateCardNumber
  };
};
exports.getCardNumberProps = getCardNumberProps;
var getCardExpiryErrorMessages = function getCardExpiryErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.cardExpiryFieldMessages.invalidCardExpiry),
    cardExpired: formatMessage(_fieldsMessages.cardExpiryFieldMessages.cardExpired)
  };
};
exports.getCardExpiryErrorMessages = getCardExpiryErrorMessages;
var getCardExpiryProps = function getCardExpiryProps(formatMessage) {
  return {
    errorMessages: getCardExpiryErrorMessages(formatMessage),
    formatValue: _nativePaymentUtils.formatCardExpiry,
    label: formatMessage(_fieldsMessages.cardExpiryFieldMessages.label),
    name: 'cardExpiry',
    placeholder: formatMessage(_fieldsMessages.cardExpiryFieldMessages.placeholder),
    validate: _nativePaymentValidations.validateCardExpiry
  };
};
exports.getCardExpiryProps = getCardExpiryProps;
var getCardCVVErrorMessages = function getCardCVVErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.cardCVVFieldMessages.invalidCardCVV)
  };
};
exports.getCardCVVErrorMessages = getCardCVVErrorMessages;
var getCardCVVProps = function getCardCVVProps(formatMessage) {
  return {
    errorMessages: getCardCVVErrorMessages(formatMessage),
    formatValue: _nativePaymentUtils.formatCardCVV,
    label: formatMessage(_fieldsMessages.cardCVVFieldMessages.label),
    name: 'cardCVV',
    placeholder: formatMessage(_fieldsMessages.cardCVVFieldMessages.placeholder),
    validate: _nativePaymentValidations.validateCardCVV
  };
};
exports.getCardCVVProps = getCardCVVProps;
var getCountryErrorMessages = function getCountryErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.countryFieldMessages.invalidCountry)
  };
};
exports.getCountryErrorMessages = getCountryErrorMessages;
var getCountryProps = function getCountryProps(formatMessage) {
  return {
    errorMessages: getCountryErrorMessages(formatMessage),
    label: formatMessage(_fieldsMessages.countryFieldMessages.label),
    name: 'country',
    placeholder: formatMessage(_fieldsMessages.countryFieldMessages.placeholder),
    validate: _validations.validateIsEmpty
  };
};
exports.getCountryProps = getCountryProps;
var getStateErrorMessages = function getStateErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.stateFieldMessages.invalidState)
  };
};
exports.getStateErrorMessages = getStateErrorMessages;
var getStateProps = function getStateProps(formatMessage) {
  return {
    errorMessages: getStateErrorMessages(formatMessage),
    label: formatMessage(_fieldsMessages.stateFieldMessages.label),
    name: 'state',
    placeholder: formatMessage(_fieldsMessages.stateFieldMessages.placeholder),
    validate: _validations.validateIsEmpty
  };
};
exports.getStateProps = getStateProps;
var getZipCodeErrorMessages = function getZipCodeErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.zipCodeFieldMessages.invalidZipcode)
  };
};
exports.getZipCodeErrorMessages = getZipCodeErrorMessages;
var getZipCodeProps = function getZipCodeProps(formatMessage) {
  return {
    errorMessages: getZipCodeErrorMessages(formatMessage),
    label: formatMessage(_fieldsMessages.zipCodeFieldMessages.label),
    name: 'zipCode',
    placeholder: formatMessage(_fieldsMessages.zipCodeFieldMessages.placeholder),
    validate: _nativePaymentValidations.validateZipCode
  };
};
exports.getZipCodeProps = getZipCodeProps;
var getAddressLineErrorMessages = function getAddressLineErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.addressLineFieldMessages.invalidAddressLine),
    isInvalidValue: formatMessage(_fieldsMessages.addressLineFieldMessages.invalidAddressValue)
  };
};
exports.getAddressLineErrorMessages = getAddressLineErrorMessages;
var getAddressLineProps = function getAddressLineProps(formatMessage) {
  return {
    errorMessages: getAddressLineErrorMessages(formatMessage),
    label: formatMessage(_fieldsMessages.addressLineFieldMessages.label),
    maxlength: 35,
    name: 'addressLine',
    placeholder: formatMessage(_fieldsMessages.addressLineFieldMessages.placeholder),
    validate: _nativePaymentValidations.validateInputFieldValue
  };
};
exports.getAddressLineProps = getAddressLineProps;
var getAddressLineTwoErrorMessages = function getAddressLineTwoErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.addressLineTwoFieldMessages.invalidAddressLine),
    isInvalidValue: formatMessage(_fieldsMessages.addressLineFieldMessages.invalidAddressValue)
  };
};
exports.getAddressLineTwoErrorMessages = getAddressLineTwoErrorMessages;
var getAddressLineTwoProps = function getAddressLineTwoProps(formatMessage) {
  return {
    errorMessages: getAddressLineTwoErrorMessages(formatMessage),
    label: formatMessage(_fieldsMessages.addressLineTwoFieldMessages.label),
    maxlength: 35,
    name: 'addressLineTwo',
    placeholder: formatMessage(_fieldsMessages.addressLineTwoFieldMessages.placeholder),
    validate: _nativePaymentValidations.validateInputFieldValue
  };
};
exports.getAddressLineTwoProps = getAddressLineTwoProps;
var getCityErrorMessages = function getCityErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.cityFieldMessages.invalidCity),
    isInvalidValue: formatMessage(_fieldsMessages.cityFieldMessages.invalidCityValue)
  };
};
exports.getCityErrorMessages = getCityErrorMessages;
var getCityProps = function getCityProps(formatMessage) {
  return {
    errorMessages: getCityErrorMessages(formatMessage),
    label: formatMessage(_fieldsMessages.cityFieldMessages.label),
    name: 'city',
    placeholder: formatMessage(_fieldsMessages.cityFieldMessages.placeholder),
    validate: _nativePaymentValidations.validateInputFieldValue
  };
};
exports.getCityProps = getCityProps;
var getNameErrorMessages = function getNameErrorMessages(formatMessage) {
  return {
    isEmptyMessage: formatMessage(_fieldsMessages.fieldsErrorMessages.incompleteField),
    isInvalidMessage: formatMessage(_fieldsMessages.nameErrorFieldMessages.invalidNameField)
  };
};
exports.getNameErrorMessages = getNameErrorMessages;